export default class DynamicForm {

	constructor(name) {
		window[name] = this.data()
	}

	data() {
		return {
			endpoint: null,
			successMessage: null,
			errorMessage: null,
			loading: false,
			Serialize(formElement) {
				var serialized = {};
				for (var i = 0; i < formElement.elements.length; i++) {
					var field = formElement.elements[i];
					// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
					if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
					// If a multi-select, get all selections
					if (field.type === 'select-multiple') {
						for (var n = 0; n < field.options.length; n++) {
							if (!field.options[n].selected) continue;
						}
					} else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
						serialized[field.name] = field.value;
					}
				}

				return serialized;
			},

			Submit(vm = this) {
				
				this.clear()

				var xhttp = new XMLHttpRequest();

				xhttp.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.responseText);
						if (typeof(response.error) !== 'undefined') {
							vm.errorMessage = response.error
							vm.loading = false
							return false
						}
						if (typeof(response.validation) !== 'undefined') {
							vm.ValidationResponse(response.validation);
							vm.loading = false
							return false
						}

						setTimeout(function() {
							vm.loading = false
							vm.successMessage = "Opgeslagen"
						}, 200)

					}
				};

				xhttp.open('post', this.endpoint, true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				console.log(this.Serialize(this.$el));

				xhttp.send(JSON.stringify(this.Serialize(this.$el)));
			},
			clear(){
				this.loading = true
				this.errorMessage = null
				this.successMessage = null
				document.querySelectorAll('.woonmens-validation-message').forEach(el => { if(el) el.remove();});
				document.querySelectorAll('.has-errors').forEach(el => { if(el) el.classList.remove('has-errors')});
			},
			ValidationResponse(ValidationResponse) {
				if (typeof(ValidationResponse) !== 'undefined') {

					this.errorMessage = 'Een of meerdere velden zijn onjuist ingevuld'

					Object.keys(ValidationResponse).forEach(function(item) {
						console.log(item);
						var el = document.querySelector('[name="' + item + '"]')
						console.log(el);
						if (el) {
							el.parentNode.classList.add('has-errors')
							el.insertAdjacentHTML('afterend', '<div class="woonmens-validation-message">' + ValidationResponse[item] + '</div>');
							el.addEventListener('focus', function() {
								el.parentNode.classList.remove('has-errors')
							})
						}
					});
				};
			},
		}
	}
}